export default __webpack_public_path__ + "static/media/oxalic-acid.c00714d5.jpg";